import { createElement } from 'src/app/core/helpers/dom';
import { GET_PREFERENCES } from 'src/app/project/modules/preferences/preferences.store';
import { TPointCustomField } from 'src/app/project/view-models/custom-field-response-model';
import { GET_TIMELINE_COLUMNS } from '../../timeframes/timeline-timeframes';
import { GET_TIMELINE } from '../../timeline.ui.store';
import { onResizeHandleMouseDown } from './on-resize-handle-mouse-down';
import { onResizeHandleRightMouseMove } from './on-resize-handle-right-mouse-move';
import { onResizeHandleRightMouseUp } from './on-resize-handle-right-mouse-up';
import { onResizeHandleRightScrollMove } from './on-resize-handle-right-scroll-move';

export function createTimelineResizeHandleRight(
  _pointIndex: number,
  _width: number,
  _timelineField: TPointCustomField,
  _canEdit: boolean,
  _element: HTMLElement,
): HTMLElement {
  let resizeHandlerElementRect: Partial<DOMRect> = {};
  let offsetX = 0;
  let startOffset = 0;
  let classList = 'timeline__resizeHandle timeline__resizeHandle--right';
  let initialScroll;
  let mouseMoveChangeAmount;

  const timeline = GET_TIMELINE();
  const timelineData = GET_TIMELINE_COLUMNS();
  const preferences = GET_PREFERENCES();

  if (_canEdit) {
    classList += ' timeline__resizeHandle--editable';
  }

  const mouseup = (_event: MouseEvent): void => {
    onResizeHandleRightMouseUp({
      _event,
      _element,
      resizeHandlerElement,
      preferences,
      timelineData,
      timeline,
      _pointIndex,
      _timelineField,
    });
  };

  const scrollmove = (): void => {
    onResizeHandleRightScrollMove({
      timeline,
      mouseMoveChangeAmount,
      initialScroll,
      _width,
      resizeHandlerElement,
    });
  };

  const mousemove = (_event: MouseEvent): void => {
    ({ mouseMoveChangeAmount, initialScroll } = onResizeHandleRightMouseMove({
      _event,
      resizeHandlerElementRect,
      offsetX,
      startOffset,
      timeline,
      _width,
      mouseMoveChangeAmount,
      initialScroll,
      resizeHandlerElement,
    }));
  };

  const resizeHandlerElement: HTMLElement = createElement('div', {
    attrs: {
      class: classList,
    },
    eventListeners: {
      click: () => {
        if (!timeline.resizing) {
          timeline.openPointCallback(timeline.getPoints()[_pointIndex]);
        }
      },
      mousedown: (_event) => {
        ({ initialScroll, startOffset, offsetX, resizeHandlerElementRect } =
          onResizeHandleMouseDown({
            _canEdit,
            initialScroll,
            _event,
            startOffset,
            resizeHandlerElement,
            offsetX,
            resizeHandlerElementRect,
            mouseup,
            mousemove,
            scrollmove,
          }));
      },
    },
  });

  return resizeHandlerElement;
}
